import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsApplemusicComponent } from './simple-icons-applemusic.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsApplemusicComponent ],
    exports:      [ SimpleIconsApplemusicComponent ],
    bootstrap:    []
})
export class SimpleIconsApplemusicModule {}
